export const limitWord = (word = '', wordCount = 15, replaceString = 'string') => {
  if (typeof word === 'string') {
    return word.length >= wordCount ? replaceString : word;
  }
  return '';
};
